module.exports = __webpack_public_path__ + "static/bg.6fd9ba0c.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/network/bg.png
// module id = 239
// module chunks = 0